import { getBudgetStatusLabel } from '../../../../enums/budgetStatus';
import { getStatusColor, isStatusWithBadge } from '../../utils';

interface IStatusBadgeProps {
  status: string;
}

const StatusBadge = (props: IStatusBadgeProps) => {
  const displayStatus = getBudgetStatusLabel(props.status);
  
  if (isStatusWithBadge(props.status)) {
    return (
      <span
        className={`py-2 rounded-full text-size-12 text-center inline-block whitespace-nowrap px-6 ${getStatusColor(
          props.status
        )}`}
      >
        {displayStatus}
      </span>
    );
  }

  return <span>{displayStatus}</span>;
};

export default StatusBadge;

